import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { LibraryService } from '@app/services/app/library.service';

import * as Objects from '@core/objects';
import { AccessVersionStatus, AccessVersion } from '@app/models/access';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { VersionListItemMenuClick } from '@core/components/versions/list/version-list-item-menu-click';
import { InterfaceListenerService } from '@core/services/interface-listener/interface-listener.service';

@Component({
  selector: 'version-helper-three-dot-status-update-menu',
  templateUrl: './three-dot-status-update-menu.component.html',
  styleUrls: ['./three-dot-status-update-menu.component.scss']
})
export class VersionHelperThreeDotStatusUpdateMenuComponent implements OnInit, OnDestroy {


  public readonly ACCESS_CHANGE_STATUS =  'access_version_change_status';

  @Input() menu: Array<ThreeDotsMenuItem> = [];
  @Input() version: Objects.Version = null;

  @Output() action = new EventEmitter<string>();
  @Output() actionStatus = new EventEmitter<Objects.Status>();

  public open: boolean = false;
  public statusOpen: boolean = false;

  private wasInside: boolean = false;

  public versionAccess: AccessVersion = null;
  public futureStatus: Array<Objects.Status> = [];
  public allVersionStatus: Array<Objects.Status> = null;
  public allowedVersionStatus: Array<Objects.Status> = [];

  protected statusSubscriptor: Subscription;
  protected accessVersionSubscriptor: Subscription;
  protected docClickSusbs: Subscription;

  constructor(
    private librarySrv: LibraryService,
    private iListenerSrv: InterfaceListenerService
  ) { }

  ngOnInit() {

    this.docClickSusbs = this.iListenerSrv.getDocuementClicked$().subscribe((value: any ) => {
      // this listen all clicks in the document, so we need to check what was ours
      if(this.open && !this.wasInside){
          this.open = false;
      } else {
          this.wasInside = false;
      }
    });

    if(this.version != null ){ 
      // get access from the library store. 
      this.accessVersionSubscriptor = this.librarySrv.selectVersionStatusAccess(this.version.status.id).subscribe((AccessVS: AccessVersionStatus) => {
          if(AccessVS != null ){
            this.allVersionStatus = AccessVS.access.status;
            this.versionAccess = AccessVS.access.grants;
            this.updateAllowedStatus();
          }
      });
    }

   
  }

  ngOnDestroy(): void {
    this.docClickSusbs.unsubscribe();
    if(this.accessVersionSubscriptor)
      this.accessVersionSubscriptor.unsubscribe();
    if(this.statusSubscriptor)
      this.statusSubscriptor.unsubscribe();
    
  }

  // this is the only click inside to open the menu,  
  toggleMenu() : void {
    this.open = !this.open;
    this.wasInside = true;
  }

  toggleStatus() : void {
    this.statusOpen = !this.statusOpen;
    this.wasInside = true
  }

  onMenuClick(key: string) : void {
    // console.log(" version status 3 dot menu item click"+key)
    this.wasInside = false;
    this.action.emit(key);
  }


  onStatusMenuSelect(status: Objects.Status) : void{
    // use the the parent store to update status
    this.actionStatus.emit(status);
    this.toggleStatus();
    this.open = !this.open;
    this.wasInside = false;
  }


  protected updateAllowedStatus(){
    if(this.allVersionStatus != null && this.versionAccess != null){
        this.allowedVersionStatus = this.versionAccess[this.ACCESS_CHANGE_STATUS] ? this.allVersionStatus.filter((s: Objects.Status) => s.id != this.version.status.id) : [];
    }
    
}


}
